import { createSelector } from '@reduxjs/toolkit';
import {RootState} from "../../../../types";

const selectVoiceModels = (state: RootState) => state.voiceModels;

export const selectVoices = createSelector(
    selectVoiceModels,
    voiceModels => voiceModels?.voices,
);

export const selectPublicVoices = createSelector(
    selectVoiceModels,
    voiceModels => voiceModels?.publicVoices,
);

export const selectTtsVoices = createSelector(
    selectVoiceModels,
    voiceModels => voiceModels?.ttsVoices,
);

export const selectTtsPublicVoices = createSelector(
    selectVoiceModels,
    voiceModels => voiceModels?.ttsPublicVoices,
);

export const selectIsLoading = createSelector(
    selectVoiceModels,
    voiceModels => voiceModels?.isLoading,
);

export const selectSelectedPreviewVoice = createSelector(
    selectVoiceModels,
    voiceModels => voiceModels?.selectedPreviewVoice,
);

export const selectVoiceById = (state, voiceModelId) => state.voiceModels?.voices.find((v) => v.id === voiceModelId)
